const OAUTH_POST_AUTH_REDIRECT_KEY = 'oauthPostAuthRedirect';

export const setOAuthPostAuthRedirect = (path) => {
  if (path && typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')) {
    sessionStorage.setItem(OAUTH_POST_AUTH_REDIRECT_KEY, path);
  } else {
    sessionStorage.removeItem(OAUTH_POST_AUTH_REDIRECT_KEY);
  }
};

export const peekOAuthPostAuthRedirect = () => {
  const value = sessionStorage.getItem(OAUTH_POST_AUTH_REDIRECT_KEY);
  if (value && value.startsWith('/') && !value.startsWith('//')) {
    return value;
  }
  return null;
};

export const consumeOAuthPostAuthRedirect = () => {
  const value = peekOAuthPostAuthRedirect();
  sessionStorage.removeItem(OAUTH_POST_AUTH_REDIRECT_KEY);
  return value;
};
